/**
 * RelatedCategories  Functional Component
 * @Package - seo/part
 * @Author - Cybage@UPWA-Team
 * @description: RelatedCategories related to part SEO
 */
/**
 *  Part SEO's RelatedCategories Component
 */
import React from 'react'
import SeoRelatedCategories from '../../SeoRelatedCategories'

export default function RelatedCategories({ dynamicApiData }) {
  const hasRelatedCategories = Boolean(dynamicApiData && Object.keys(dynamicApiData).length)

  if (!hasRelatedCategories) {
    return ''
  }

  return (
    <SeoRelatedCategories
      id="PartRelatedCategories"
      data={dynamicApiData}
    />
  )
}
